import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// TO DO: remove this import when integration to backend is complete
import pressreleases from '../../../assets/static-data/2025/media.json';
import { renderListOfCards } from '@kainos-applied-innovation/convention-frontend-components';
import featureToggles from '../../../utils/featureToggles';
import ComingSoonPage from '../comingSoonPage';

const PressReleasePage = () => {

  const [pressReleaseList, setPressRelease] = useState(pressreleases);
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('Pages.NewsUpdates.Title');
    if (!pressReleaseList) {
      setPressRelease(pressreleases);
    }
  }, []);

  if (!featureToggles.pressReleases()) {
    return <ComingSoonPage title={t('Pages.NewsUpdates.Title')} header={t('Pages.NewsUpdates.Header')} />;
  }

  return (
    <div className="con-container">
      <div className="con-content">
        <div className="con-flex__container">
          <h1 className="con-heading con-heading__l--margin-bottom-3">{t('Pages.NewsUpdates.Header')}</h1>
        </div>
        <div className="con-text__s--margin-bottom-2">
        </div>
        {renderListOfCards(pressReleaseList)}
      </div>
    </div>
  );
};

export default PressReleasePage;
